import * as React from "react";
import type { SVGProps } from "react";
const SvgTag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m21.09 13.91.707.707.002-.002zm-7.17 7.17-.707-.707zm-2.83 0 .707-.707zM2.5 12.5h-1a1 1 0 0 0 .293.707zm0-10v-1a1 1 0 0 0-1 1zm10 0 .707-.707A1 1 0 0 0 12.5 1.5zm8.59 8.59.71-.705-.003-.002zM7.5 6.5a1 1 0 0 0 0 2zm.01 2a1 1 0 0 0 0-2zm12.873 4.703-7.17 7.17 1.414 1.414 7.17-7.17zm-7.17 7.17a1 1 0 0 1-.325.217l.766 1.848a3 3 0 0 0 .973-.651zm-.325.217a1 1 0 0 1-.383.077v2a3 3 0 0 0 1.149-.23zm-.383.077a1 1 0 0 1-.383-.077l-.766 1.848a3 3 0 0 0 1.149.229zm-.383-.077a1 1 0 0 1-.325-.217l-1.415 1.414a3 3 0 0 0 .974.65zm-.325-.218-8.59-8.58-1.414 1.415 8.59 8.58zM3.5 12.5v-10h-2v10zm-1-9h10v-2h-10zm9.293-.293 8.59 8.59 1.414-1.414-8.59-8.59zm8.588 8.588a1 1 0 0 1 .29.705h2a3 3 0 0 0-.872-2.115zm.29.705a1 1 0 0 1-.29.705l1.418 1.41a3 3 0 0 0 .873-2.115zM7.5 8.5h.01v-2H7.5z"
    />
  </svg>
);
export default SvgTag;
